const EMPTY_RESULT_MUST_NOT_BE_CACHED_PATTERNS = [
  /^\/loja-virtual\/v1\/produtos\/relacionados(?:\?|$)/,
  /^\/loja-virtual\/v1\/produtos\/relacionados-comprejunto(?:\?|$)/,
]

export function shouldCacheStorefrontCatalogResponse(endpoint: string, value: unknown): boolean {
  if (!EMPTY_RESULT_MUST_NOT_BE_CACHED_PATTERNS.some((pattern) => pattern.test(endpoint))) {
    return true
  }

  if (!value || typeof value !== 'object') {
    return true
  }

  const items = (value as { items?: unknown }).items
  return !Array.isArray(items) || items.length > 0
}
